function status_lezione(input) {
    if (typeof input === "string") {
    if (input==="Programmata"){
    return 1
    }
    else if (input==="Conclusa"){
    return 2}
    else if (input==="Cancellata"){
    return 3}
    else if (input==="Noshow"){
    return 4}}
    else {
    if (input===1){
    return "Programmata"
    }
    else if (input===2){
    return "Conclusa"}
    else if (input===3){
    return "Cancellata"}
    else if (input===4){
    return "Noshow"}}
    }

export default status_lezione